/** Reflects data structure returned by the new OBS token request */
export interface IAuthObsTokenResponse {
    token: string;
}
